import axios from 'axios';

type Presentation = {
    presentationId: number | null
}

type CreatePresentationBody = {
    presentationType: string,
    presentationStart: Date | null,
    salesRepId: number
}

type UpdatePresentationBody = {
    presentationId: number,
    presentationStart: Date | null
    presentationEnd: Date | null
}

export const createPresentation = async ({ presentationType, presentationStart, salesRepId }: CreatePresentationBody): Promise<Presentation> => {
    const { data: newPresentation } = await axios.post('/api/presentation', { presentationType, presentationStart, salesRepId });

    return ({ presentationId: newPresentation.id ?? null });
};

export const updatePresentationStart = async ({ presentationId, presentationStart }: UpdatePresentationBody): Promise<boolean> => {
    await axios.put('/api/presentation', { presentationId, presentationStart });

    return true;
};

export const updatePresentationEnd = async ({ presentationId, presentationEnd }: UpdatePresentationBody): Promise<boolean> => {
    await axios.put('/api/presentation', { presentationId, presentationEnd });

    return true;
};

